var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: !_vm.hidden,
          expression: "!hidden"
        }
      ],
      staticClass: "cjt-customer"
    },
    [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "support-widget-btn", attrs: { id: "support-launcher" } },
      [
        _c("img", {
          staticClass: "icon",
          attrs: {
            src:
              "https://static.xyb2b.com/images/044e765b2ee3aa1002f90572c24ecbb2.svg",
            alt: ""
          }
        }),
        _vm._v(" "),
        _c("div", [_vm._v("咨询")])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "phone" }, [
      _c("img", {
        staticClass: "icon",
        attrs: {
          src:
            "https://static.xyb2b.com/images/76af9d94d49793a86c4c2862112c0563.svg",
          alt: ""
        }
      }),
      _vm._v(" "),
      _c("div", {}, [_vm._v("热线")]),
      _vm._v(" "),
      _c("div", { staticClass: "phone-pop" }, [
        _c("div", { staticClass: "phone-list" }, [
          _vm._v("\n        4008热线: 4001828088\n        "),
          _c("div", { staticClass: "arrow" })
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wx" }, [
      _c("img", {
        staticClass: "icon",
        attrs: {
          src:
            "https://static.xyb2b.com/images/9bb6891a4df122b30b6f01fe6aa7b0e1.svg",
          alt: ""
        }
      }),
      _vm._v(" "),
      _c("div", {}, [_vm._v("公众号")]),
      _vm._v(" "),
      _c("div", { staticClass: "wx-pop" }, [
        _c("img", {
          attrs: {
            src:
              "https://static.xyb2b.com/images/2b1fc007fdfa8e5de0facdca83269768.png",
            alt: ""
          }
        })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2ed32419", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ed32419","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./xcloud-client-components-web/module/components/SideService/index.vue
// module id = null
// module chunks = 